var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.605,
    height: 13.012,
    viewBox: "0 0 39.605 13.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "visa",
    d: "M9.9,13.342H6.474L3.9,3.247a1.626,1.626,0,0,0-.762-1.068A10.938,10.938,0,0,0,0,1.111V.722H5.522A1.453,1.453,0,0,1,6.951,1.984L8.284,9.265,11.71.722h3.332Zm7.046,0H13.71L16.376.721h3.237ZM23.8,4.217a1.263,1.263,0,0,1,1.334-1.068,5.881,5.881,0,0,1,3.142.582l.572-2.717A7.989,7.989,0,0,0,25.9.43c-3.142,0-5.428,1.748-5.428,4.174,0,1.846,1.619,2.815,2.762,3.4,1.237.582,1.713.971,1.618,1.553,0,.873-.953,1.262-1.9,1.262a7.967,7.967,0,0,1-3.332-.777l-.572,2.719a9.106,9.106,0,0,0,3.523.68c3.523.1,5.712-1.65,5.712-4.272,0-3.3-4.475-3.494-4.475-4.95Zm15.8,9.124L37.035.721H34.275a1.435,1.435,0,0,0-1.334.971l-4.76,11.649h3.332l.665-1.844h4.094l.381,1.844ZM34.751,4.12,35.7,8.876H33.036Z",
    transform: "translate(0 -0.431)",
    fill: "#172b85",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d0a2d7e445949f27b263ce769c902665.svg";
export { ForwardRef as ReactComponent };